import React, { useCallback, type MouseEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { LeftFooterButton } from '../../../common/ui/left-footer-button/index.tsx';
import messages from './messages.tsx';

type Props = {
	onClear?: () => void;
};

export const ClearSelectedItemsButton = ({ onClear }: Props) => {
	const { formatMessage } = useIntl();

	const onClearSelectedItems = useCallback(
		(mouseEvent: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
			fireUIAnalytics(analyticsEvent, 'filterSearchClearSelectedItems', {
				// If number of clicks is 0, button was actioned using the keyboard
				keyboard: mouseEvent.detail === 0,
			});

			onClear && onClear();
		},
		[onClear],
	);

	const message = formatMessage(messages.clearAllSelectedItemsButtonText);

	return (
		<LeftFooterButton
			message={message}
			onClick={onClearSelectedItems}
			appearance="subtle-link"
			testId="jql-builder-basic-picker.ui.async-select.clear-selection-button.clear-selected-items"
			hasTooltip
		/>
	);
};

export default ClearSelectedItemsButton;
